import React from "react"
import clsx from "clsx"
import { FlexBox } from "@components/wrapper"

export interface TextAreaInputProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  errorText?: string
  inputClassName?: string
  maxCharacter?: number
  minCharacter?: number
  noBorder?: boolean
}

export const TextArea: React.FC<TextAreaInputProps> = ({
  minCharacter,
  maxCharacter = 300,
  className,
  inputClassName,
  value,
  errorText,
  noBorder,
  ...props
}) => {
  const val = value as string

  let textAreaInfo

  switch (true) {
    case typeof errorText === "string" && errorText.length > 0:
      textAreaInfo = <small className="text-red">{errorText}</small>
      break
    case typeof minCharacter === "number":
      textAreaInfo = (
        <small className={clsx(errorText?.length && "text-red")}>
          Minimal {minCharacter ?? 0} Karakter
        </small>
      )
      break
    default:
      textAreaInfo = <small>Maksimal {maxCharacter ?? 0} Karakter</small>
      break
  }

  return (
    <div className={clsx("relative", className)}>
      <textarea
        {...props}
        value={value}
        maxLength={maxCharacter}
        className={clsx(
          inputClassName,
          "py-2.5 px-3 rounded-xl w-full",
          "focus:outline-none focus:shadow-outline",
          errorText && "border-red border"
        )}
      />
      <FlexBox justify="between">
        {textAreaInfo}
        <small>
          {maxCharacter
            ? `(${val?.length ?? 0}/${maxCharacter})`
            : `(${val?.length ?? 0} karakter)`}
        </small>
      </FlexBox>
    </div>
  )
}
